export enum PORTFOLIO_ASSET_ALLOCATION {
  ALTERNATIVE_INVESTMENT = 'Alternative Investment',
  EQ = 'Equity',
  CANADIAN_EQ = 'Canadian Equity',
  US_EQ = 'United States Equity',
  FOREIGN_EQ = 'Foreign Equity',
  FIXED_INCOME = 'Fixed Income',
  CASH = 'Cash',
  REAL_ASSETS = 'Real Assets',
  OTHER = 'Other',
}

export enum DETAILED_ASSET_ALLOCATION {
  ALTERNATIVE_INVESTMENT = 'Alternative Investment',
  EQ = 'Equity',
  CANADIAN_EQ = 'Canadian Equity',
  US_EQ = 'United States Equity',
  FOREIGN_EQ = 'Foreign Equity',
  FIXED_INCOME_US = 'United States Fixed Income',
  FIXED_INCOME_CAN = 'Canadian Fixed Income',
  FIXED_INCOME_FOREIGN = 'Foreign Fixed Income',
  FIXED_INCOME = 'Fixed Income',
  CASH = 'Cash',
  REAL_ASSETS = 'Real Assets',
  OTHER = 'Other',
}

export enum COUNTRY_ALLOCATION {
  CA = 'Canada',
  USA = 'United States',
  FRA = 'France',
  GBR = 'United Kingdom',
  GER = 'Germany',
  AUS = 'Australia',
  CHN = 'China',
  JPN = 'Japan',
  HKG = 'Hong Kong',
  IND = 'India',
  ARE = 'United Arab Emirates',
  NLD = 'Netherlands',
  UNIDENTIFIED = 'Unidentified',
}

// dataKey represents the key used in LGDF data
export const HOLDING_TYPE_ALLOCATION = Object.freeze([
  { key: 'EQ', dataKey: 'Equity' },
  { key: 'FI', dataKey: 'Bond' },
  { key: 'CASH', dataKey: 'M' },
  { key: 'OTHER', dataKey: 'Other' },
]);
